import App from 'app/app.js';
import 'app/store/UserProfileStore.js';
import 'app/service/RouterService.js';
import 'app/store/MessageStore.js';

function LtEnhancedPayonlyContinueShoppingCtrl(
  $scope,
  MessageStore,
  ContentStore,
  $filter,
  PortraitIdFormatterService
) {
  this.portraitId = $scope.portraitId;
  this.accessCode = $scope.accessCode;
  this.subjectLastName = null;
  this.showFindCredentials = false;

  this.init = function () {
    var unwatchPortraitId = $scope.$watch(
        'portraitId',
        function (portraitId) {
          this.portraitId = portraitId;
        }.bind(this)
      ),
      unwatchSubjectLastName = $scope.$watch(
        'subjectLastName',
        function (subjectLastName) {
          this.subjectLastName = subjectLastName;
        }.bind(this)
      ),
      unwatchAccessCode = $scope.$watch(
        'accessCode',
        function (accessCode) {
          this.accessCode = accessCode;
        }.bind(this)
      );

    $scope.$on('$destroy', function () {
      unwatchPortraitId();
      unwatchAccessCode();
      unwatchSubjectLastName();
    });
  };

  this.onContinue = function () {
    var form = $('#lt-enhanced-pay-only-continue-shopping-form').first();
    var formData = {};
    if (this.isPictureDayFormValid() || this.validateAccountInfo()) {
      if (this.isPortraitIdEntered()) {
        formData.portraitId = this.formatInputTextFields(this.portraitId);
        formData.accessCode = this.formatInputTextFields(this.accessCode);

        //if form is pristine, drop this from the request params to prevent invalid state
        if (form.hasClass('ng-pristine')) {
          formData.subjectLastName = null;
        } else {
          formData.subjectLastName = this.formatInputTextFields(this.subjectLastName);
        }
      }

      $scope.onContinue({ formData: formData });
    }
  };

  this.validateData = function () {
    return ValidationService.validate([
      {
        field: $scope.pictureIdForm.accessCode,
        validation: 'required',
        code: 'ACCESS_CODE_REQUIRED'
      },
      {
        field: $scope.pictureIdForm.subjectLastName,
        validation: 'required',
        code: 'CLAIM_CREDENTIALS_REQUIRED_LAST_NAME'
      }
    ]);
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };

  this.getPlaceholderByCountry = function (key) {
    key = ContentStore.appendCountryCode(key);
    return this.getPlaceholder(key);
  };

  this.formatInputTextFields = function (text) {
    return (text && text.trim().toUpperCase()) || '';
  };

  this.validateAccountInfo = function () {
    var errors = this.validateData();

    MessageStore.clear();
    if (errors.length > 0) {
      R.forEach(function (error) {
        MessageStore.createSystem(error.code, error.params);
      })(errors);
      $window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    return true;
  };

  this.disableShopNowButton = function () {
    var form = $('#lt-enhanced-pay-only-continue-shopping-form').first();

    if (form.hasClass('ng-pristine') && !!this.portraitId) {
      //we can assume app supplied values are valid
      return false;
    } else {
      if (this.isPortraitIdEntered()) {
        return !(this.isAccessCodeValid() && this.isSubjectLastNameValid());
      }
      return true;
    }
  };

  this.isPictureDayFormValid = function () {
    return this.isPortraitIdValid() && (!this.isPortraitIdEntered() || this.isAccessCodeValid());
  };

  this.isPortraitIdValid = function () {
    return !!this.portraitId && this.portraitId.length > 0;
  };

  this.isAccessCodeValid = function () {
    return !!this.accessCode && this.accessCode.trim().length > 0;
  };

  this.isSubjectLastNameValid = function () {
    return !!this.subjectLastName && this.subjectLastName.length > 0;
  };

  this.isPortraitIdEntered = () => PortraitIdFormatterService.isFormattedPortraitId(this.portraitId);

  this.resetFormValues = function () {
    this.portraitId = null;
    this.accessCode = null;
    this.subjectLastName = null;
    MessageStore.clear();
  };

  this.toggleFindCredentials = function () {
    this.showFindCredentials = !this.showFindCredentials;
  };

  this.close = function () {
    this.resetFormValues();
    $scope.onCancel();
  };
}

App.controller('LtEnhancedPayonlyContinueShoppingCtrl', [
  '$scope',
  'MessageStore',
  'ContentStore',
  '$filter',
  'PortraitIdFormatterService',
  LtEnhancedPayonlyContinueShoppingCtrl
]);
